import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './App.js';

const Navbar = ({ signOut }) => {
  const location = useLocation();

  return (
    <nav className="navbar"> {}
      <div className="nav-container">
        <ul className="nav-list">
          <li className="nav-item">
            <NavLink to="/home" end className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/request-coverage" className={({ isActive }) => (isActive || location.pathname === '/request-submitted' ? 'nav-link active' : 'nav-link')}>
              Request
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to="/claim-coverage" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
              Claim
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;